import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Dialog,
  Button,
  IconButton,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { TEMPLATES } from "../components/templates";
import BackButton from "./utils/BackButton";
import { Helmet } from "react-helmet-async";

export default function AllTemplatesPage() {
  const navigate = useNavigate();
  const [preview, setPreview] = useState(null);

  const popular = TEMPLATES.filter((t) => t.category === "popular");
  const others = TEMPLATES.filter((t) => t.category === "other");

  const handleSelect = (template) => {
    navigate("/create-biodata", {
      state: {
        selectedBg: template.value,
        theme: template.theme,
      },
    });
  };

  const renderTemplates = (list, showBadge = false) => (
    <Grid container spacing={2}>
      {list.map((t, i) => (
        <Grid item xs={6} sm={4} md={3} key={i}>
          <Paper
            elevation={2}
            onClick={() => setPreview(t)}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              cursor: "pointer",
              position: "relative",
              transition: "0.3s",

              "&:hover": {
                transform: "translateY(-6px)",
                boxShadow: "0 12px 25px rgba(0,0,0,0.25)",
              },
            }}
          >
            {/* Image */}
            <Box
              sx={{
                width: "100%",
                aspectRatio: "210 / 297",
                backgroundImage: `url(${t.key})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />

            {/* Badge */}
            {showBadge && (
            <Box
              sx={{
                position: "absolute",
                top: 8,
                left: 8,
                background: "#FF5E62",
                color: "#fff",
                px: 1,
                py: 0.3,
                fontSize: "0.7rem",
                borderRadius: 1,
                fontWeight: 600,
              }}
            >
              Popular
            </Box>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <>
      {/* ✅ SEO */}
      <Helmet>
        <title>Marriage Biodata Templates (Free Download)</title>
        <meta
          name="description"
          content="Browse modern marriage biodata templates. Choose a design, preview it, and create your biodata instantly for free."
        />
        <link
          rel="canonical"
          href="https://www.marriagebiodata.live/marriage-biodata-templates"
        />
      </Helmet>

      <Box sx={{ px: 2, py: 3, maxWidth: 1100, mx: "auto" }}>
        <BackButton fallback="/" />

        {/* ✅ H1 */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 800, mb: 2, textAlign: "center" }}
        >
          Marriage Biodata Templates
        </Typography>

        {/* ✅ SEO CONTENT (SHORT + POWERFUL) */}
        <Typography
          sx={{
            textAlign: "center",
            maxWidth: 700,
            mx: "auto",
            mb: 4,
            color: "#555",
            lineHeight: 1.7,
          }}
        >
          Explore a collection of modern and traditional marriage biodata templates.
          Select your preferred design, preview it, and create your biodata online
          instantly. All templates are free to use and easy to customize.
        </Typography>

        {/* 🔥 Popular */}
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>
          Popular Templates
        </Typography>

        {renderTemplates(popular, true)}

        {/* 🔥 Others */}
        <Typography variant="h6" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          All Templates
        </Typography>

        {renderTemplates(others)}

        {/* ================= PREVIEW MODAL ================= */}
        <Dialog
          open={Boolean(preview)}
          onClose={() => setPreview(null)}
          maxWidth="md"
          fullWidth
        >
          {/* Close */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            <IconButton onClick={() => setPreview(null)}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Preview */}
          <Box sx={{ p: 2 }}>
            <Box
              sx={{
                width: "100%",
                aspectRatio: "210 / 297",
                backgroundImage: `url(${preview?.key})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                minHeight: 500,
                backgroundColor: "#fff",
              }}
            />
          </Box>

          {/* CTA */}
          <Box sx={{ textAlign: "center", pb: 3 }}>
            <Button
              variant="contained"
              onClick={() => {
                handleSelect(preview);
                setPreview(null);
              }}
              sx={{
                px: 4,
                py: 1.2,
                borderRadius: 3,
                fontWeight: 700,
                textTransform: "none",
              }}
            >
              Use This Template
            </Button>
          </Box>
        </Dialog>
      </Box>
    </>
  );
}